import { Typography } from 'antd';
import { Link } from 'react-router-dom';

interface ITitle {
  nameTable: string;
  title?: string;
  url?: string;
}
const TitleTable = ({ nameTable, title, url }: ITitle) => {
  return (
    <>
      <div className="title-table">
        <Typography.Title
          level={4}
          style={{
            padding: '1rem 2rem',
            fontWeight: '700',
            color: '#535353',
            fontSize: '12px',
            flexDirection: 'column'
          }}
        >
          {nameTable}
        </Typography.Title>
        {
          url && title ? <Typography.Title
          level={4}
          style={{
            padding: '1rem 2rem',
            fontWeight: '700',
            color: '#9A9A9A',
            fontSize: '12px',
            flexDirection: 'column'
          }}
        >
          <Link to={url}>{title}</Link>
        </Typography.Title> : null
        }
      </div>
    </>
  );
};

export default TitleTable;
